module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-left-6.99c10151.png";